var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.title,
        size: _vm.mode === "checkin" || _vm.mode === "cancel" ? "lg" : "md",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _vm.context
        ? _c(
            "div",
            { staticClass: "p-50" },
            [
              _c("div", { staticClass: "border rounded p-1 mb-1" }, [
                _c("div", { staticClass: "flex justify-between mb-25" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("lesson.agenda.occurrence"))),
                  ]),
                  _c("small", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.occurrenceLabel)),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("lesson.agenda.occupancy"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.context.slot.occupied) +
                        "/" +
                        _vm._s(
                          _vm.context.slot.capacity === null
                            ? "∞"
                            : _vm.context.slot.capacity
                        )
                    ),
                  ]),
                ]),
              ]),
              _vm.mode === "checkin"
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-between mt-2 mb-50",
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("mural.checkin.hint"))),
                        ]),
                        _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("mural.checkin.count", {
                                  present: _vm.present.length,
                                  total: _vm.context.slot.students.length,
                                })
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                    _vm._l(_vm.context.slot.students, function (student) {
                      return _c(
                        "div",
                        {
                          key: student.scheduled_event_id,
                          staticClass: "mural-check",
                          on: {
                            click: function ($event) {
                              return _vm.togglePresent(
                                student.scheduled_event_id
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex-grow",
                              staticStyle: { "min-width": "0" },
                            },
                            [
                              _c("div", { staticClass: "mural-check__name" }, [
                                _vm._v(_vm._s(student.name)),
                              ]),
                              student.gate_check_in
                                ? _c(
                                    "div",
                                    { staticClass: "mural-check__gate" },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-25",
                                        attrs: {
                                          icon: "CheckSquareIcon",
                                          size: "12",
                                        },
                                      }),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mural.checkin.gate_entry", {
                                              time: student.gate_check_in.at,
                                              channel:
                                                student.gate_check_in
                                                  .channel_label,
                                            })
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c("div", { staticClass: "text-muted" }, [
                                    _c("small", [
                                      _vm._v(_vm._s(student.email)),
                                    ]),
                                  ]),
                            ]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              attrs: {
                                variant:
                                  student.status === "DO"
                                    ? "light-success"
                                    : "light-primary",
                                pill: "",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(student.origin_label || "—") + " "
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "mural-check__box",
                              class: {
                                "mural-check__box--on": _vm.isPresent(
                                  student.scheduled_event_id
                                ),
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "CheckIcon", size: "12" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mt-1 mb-0",
                        attrs: { show: "", variant: "secondary" },
                      },
                      [
                        _c("small", [
                          _vm._v(_vm._s(_vm.$t("mural.checkin.absent_note"))),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "reschedule"
                ? [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mt-2",
                        attrs: { label: _vm.$t("mural.reschedule.new_slot") },
                      },
                      [
                        _c("b-form-select", {
                          attrs: {
                            options: _vm.slotOptions,
                            disabled: _vm.loadingSlots,
                          },
                          model: {
                            value: _vm.targetSlot,
                            callback: function ($$v) {
                              _vm.targetSlot = $$v
                            },
                            expression: "targetSlot",
                          },
                        }),
                        !_vm.loadingSlots && !_vm.slotOptions.length
                          ? _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("mural.reschedule.no_slots")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("mural.reschedule.reason") } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.reasonOptions },
                          model: {
                            value: _vm.reason,
                            callback: function ($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mb-0",
                        attrs: { show: "", variant: "warning" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("mural.reschedule.warning"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "capacity"
                ? [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mt-2",
                        attrs: { label: _vm.$t("lesson.agenda.new_capacity") },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "number",
                            min: "1",
                            max: "999",
                            placeholder:
                              "" +
                              (_vm.context.slot.capacity === null
                                ? ""
                                : _vm.context.slot.capacity),
                          },
                          model: {
                            value: _vm.capacity,
                            callback: function ($$v) {
                              _vm.capacity = _vm._n($$v)
                            },
                            expression: "capacity",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("small", { staticClass: "text-muted d-block mb-1" }, [
                      _vm._v(_vm._s(_vm.$t("lesson.agenda.capacity_hint"))),
                    ]),
                    _vm.capacity && _vm.capacity < _vm.context.slot.occupied
                      ? _c(
                          "b-alert",
                          {
                            staticClass: "p-1 mb-1",
                            attrs: { show: "", variant: "warning" },
                          },
                          [
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "lesson.agenda.capacity_below_occupancy_warning",
                                    { occupied: _vm.context.slot.occupied }
                                  )
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("lesson.agenda.reason") } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "lesson.agenda.reason_placeholder"
                            ),
                          },
                          model: {
                            value: _vm.reason,
                            callback: function ($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "block"
                ? [
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mt-2 mb-1",
                        attrs: { show: "", variant: "warning" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("lesson.agenda.block_hint"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("lesson.agenda.reason") } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "lesson.agenda.reason_placeholder"
                            ),
                          },
                          model: {
                            value: _vm.reason,
                            callback: function ($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "grant"
                ? [
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mt-2 mb-1",
                        attrs: { show: "", variant: "warning" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("schedule_event.seat_grant_hint"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("schedule_event.seat_grant_student"),
                        },
                      },
                      [
                        _c("select-suggestion", {
                          ref: "grantStudent",
                          attrs: {
                            column: "name,email",
                            model: "User",
                            label: null,
                            appendClearOption: true,
                            placeholderText: "Digite o nome ou e-mail do aluno",
                            itemTextFormat: _vm.studentItemTextFormat,
                          },
                          model: {
                            value: _vm.grantStudent,
                            callback: function ($$v) {
                              _vm.grantStudent = $$v
                            },
                            expression: "grantStudent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("schedule_event.seat_grant_scope"),
                        },
                      },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            options: _vm.grantScopeOptions,
                            stacked: "",
                            "value-field": "value",
                            "text-field": "label",
                          },
                          model: {
                            value: _vm.grantScope,
                            callback: function ($$v) {
                              _vm.grantScope = $$v
                            },
                            expression: "grantScope",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("lesson.agenda.reason") } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "lesson.agenda.reason_placeholder"
                            ),
                          },
                          model: {
                            value: _vm.reason,
                            callback: function ($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "cancel"
                ? [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mt-2",
                        attrs: {
                          label: _vm.$t("cancellation.club_cancel_reason"),
                        },
                      },
                      [
                        _c("b-form-select", {
                          staticClass: "required",
                          attrs: { options: _vm.reasonOptions },
                          model: {
                            value: _vm.reason,
                            callback: function ($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.impact && _vm.canSeeMoney
                      ? _c("div", { staticClass: "border rounded p-1 mb-1" }, [
                          _c("div", { staticClass: "font-weight-bold mb-50" }, [
                            _vm._v(
                              _vm._s(_vm.$t("cancellation.club_cancel_impact"))
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-25" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_students")
                                  )
                                ),
                              ]),
                              _c("small", [
                                _vm._v(_vm._s(_vm.impact.affected_students)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-25" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_refund")
                                  )
                                ),
                              ]),
                              _c("small", { staticClass: "hb-money" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.money(_vm.impact.full_refund_total)
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-25" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_transfer")
                                  )
                                ),
                              ]),
                              _c("small", { staticClass: "hb-money" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.money(
                                      _vm.impact.settled_transfer_reversal
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "flex justify-between" }, [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("cancellation.club_cancel_fee"))
                              ),
                            ]),
                            _c("small", { staticClass: "hb-money" }, [
                              _vm._v(
                                _vm._s(_vm.money(_vm.impact.hubee_fee_returned))
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-between items-center border rounded p-1 mb-1",
                      },
                      [
                        _c("div", [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cancellation.club_cancel_mass_reschedule"
                                )
                              )
                            ),
                          ]),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("cancellation.club_cancel_mass_hint")
                              )
                            ),
                          ]),
                        ]),
                        _c("b-form-checkbox", {
                          attrs: { switch: "" },
                          model: {
                            value: _vm.offerReschedule,
                            callback: function ($$v) {
                              _vm.offerReschedule = $$v
                            },
                            expression: "offerReschedule",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mb-0",
                        attrs: { show: "", variant: "danger" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("lesson.agenda.cancel_warning"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "flex justify-end mt-2",
                  staticStyle: { gap: ".6rem" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(_vm._s(_vm.$t("mural.actions.back")))]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: _vm.confirmVariant,
                        disabled: !_vm.canConfirm,
                      },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v(" " + _vm._s(_vm.confirmLabel) + " ")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }